export const CATEGORIES = {
  ar: [
    { val: 'all', label: 'الكل' },
    { val: 'electronics', label: 'إلكترونيات' },
    { val: 'home_appliances', label: 'أجهزة منزلية' },
    { val: 'furniture', label: 'أثاث' },
    { val: 'office_furniture', label: 'أثاث مكتبي' },
    { val: 'bedroom_furniture', label: 'أثاث غرف النوم' },
    { val: 'kitchen_furniture', label: 'أثاث المطبخ' },
    { val: 'outdoor_furniture', label: 'أثاث خارجي' },
    { val: 'home_decor', label: 'ديكور منزلي' },
    { val: 'clothing', label: 'ملابس' },
    { val: 'building', label: 'مواد بناء' },
    { val: 'food', label: 'غذاء' },
    { val: 'beauty', label: 'عناية وتجميل' },
    { val: 'sports', label: 'رياضة' },
    { val: 'toys', label: 'ألعاب' },
    { val: 'auto_parts', label: 'قطع غيار' },
    { val: 'car_accessories', label: 'إكسسوارات سيارات' },
    { val: 'tires', label: 'إطارات' },
    { val: 'lubricants', label: 'زيوت ومواد تشحيم' },
    { val: 'health', label: 'صحة وطب' },
    { val: 'packaging', label: 'تعبئة وتغليف' },
    { val: 'gifts', label: 'هدايا' },
    { val: 'agriculture', label: 'زراعة' },
    { val: 'industrial_machinery', label: 'آلات ومعدات صناعية' },
    { val: 'hospitality_supplies', label: 'معدات مطابخ تجارية وأدوات طهي' },
    { val: 'other', label: 'أخرى' },
  ],
  en: [
    { val: 'all', label: 'All' },
    { val: 'electronics', label: 'Electronics' },
    { val: 'home_appliances', label: 'Home Appliances' },
    { val: 'furniture', label: 'Furniture' },
    { val: 'office_furniture', label: 'Office Furniture' },
    { val: 'bedroom_furniture', label: 'Bedroom Furniture' },
    { val: 'kitchen_furniture', label: 'Kitchen Furniture' },
    { val: 'outdoor_furniture', label: 'Outdoor Furniture' },
    { val: 'home_decor', label: 'Home Décor' },
    { val: 'clothing', label: 'Clothing' },
    { val: 'building', label: 'Building Materials' },
    { val: 'food', label: 'Food' },
    { val: 'beauty', label: 'Beauty & Personal Care' },
    { val: 'sports', label: 'Sports' },
    { val: 'toys', label: 'Toys' },
    { val: 'auto_parts', label: 'Auto Parts' },
    { val: 'car_accessories', label: 'Car Accessories' },
    { val: 'tires', label: 'Tires' },
    { val: 'lubricants', label: 'Lubricants & Oils' },
    { val: 'health', label: 'Health & Medical' },
    { val: 'packaging', label: 'Packaging' },
    { val: 'gifts', label: 'Gifts' },
    { val: 'agriculture', label: 'Agriculture' },
    { val: 'industrial_machinery', label: 'Industrial Machinery & Equipment' },
    { val: 'hospitality_supplies', label: 'Commercial Kitchen & Cookware' },
    { val: 'other', label: 'Other' },
  ],
  zh: [
    { val: 'all', label: '全部' },
    { val: 'electronics', label: '电子产品' },
    { val: 'home_appliances', label: '家用电器' },
    { val: 'furniture', label: '家具' },
    { val: 'office_furniture', label: '办公家具' },
    { val: 'bedroom_furniture', label: '卧室家具' },
    { val: 'kitchen_furniture', label: '厨房家具' },
    { val: 'outdoor_furniture', label: '户外家具' },
    { val: 'home_decor', label: '家居装饰' },
    { val: 'clothing', label: '服装' },
    { val: 'building', label: '建材' },
    { val: 'food', label: '食品' },
    { val: 'beauty', label: '美容护肤' },
    { val: 'sports', label: '运动' },
    { val: 'toys', label: '玩具' },
    { val: 'auto_parts', label: '汽车配件' },
    { val: 'car_accessories', label: '汽车周边' },
    { val: 'tires', label: '轮胎' },
    { val: 'lubricants', label: '润滑油' },
    { val: 'health', label: '健康医疗' },
    { val: 'packaging', label: '包装材料' },
    { val: 'gifts', label: '礼品' },
    { val: 'agriculture', label: '农业' },
    { val: 'industrial_machinery', label: '工业机械与设备' },
    { val: 'hospitality_supplies', label: '商用厨房设备与炊具' },
    { val: 'other', label: '其他' },
  ],
};

// Full trilingual {val,label} lists for UI pickers/filters. Includes the
// synthetic 'all' row first (use directly for filters; for forms that select a
// real category, filter out c.val === 'all').
export const UI_CATEGORIES = CATEGORIES;

// Map a raw category/specialty code (e.g. 'home_decor', 'auto_parts')
// to its translated label using the CATEGORIES table above. Falls back
// to the raw code if no entry is found, and returns '' for empty input.
// Use this everywhere a supplier or product specialty is rendered to
// the user — never display the raw enum string directly.
export function getSpecialtyLabel(rawCode, lang = 'en') {
  const code = String(rawCode || '').trim();
  if (!code) return '';
  const list = CATEGORIES[lang] || CATEGORIES.en;
  const found = list.find((c) => c.val === code);
  return found ? found.label : code;
}

export const OFFER_STATUS = {
  ar: { pending: 'قيد المراجعة', accepted: 'مقبول', rejected: 'مرفوض' },
  en: { pending: 'Pending', accepted: 'Accepted', rejected: 'Rejected' },
  zh: { pending: '待审核', accepted: '已接受', rejected: '已拒绝' },
};

/**
 * What COLOUR an offer's status is, as a token name rather than a colour.
 *
 * Added 2026-09-22 because the admin console's offers list styled the ACCEPTED
 * offer and the REJECTED ones identically — the trader's decision, the single
 * most important fact on that list, was invisible until you read the word.
 *
 * The values are the EXISTING admin-console badge classes from
 * src/pages/admin2/console.css (.ac-badge.ok / .warn / .danger / .neutral).
 * No new colour is introduced. `pending` is warn rather than neutral because
 * on this list it means the trader has not decided yet, which is a thing
 * waiting on someone.
 *
 * ⚠️ offers.status is the TRADER'S DECISION and never the visibility gate
 * (golden rule 2 — they are deliberately separate columns). A tone here says
 * what the trader chose, NOT whether we have approved the quote. The
 * visibility chip is offerVisibility.js and stays separate.
 *
 * Lives beside OFFER_STATUS rather than in the console, so the word and its
 * colour cannot drift apart and any second consumer gets both.
 */
export const OFFER_STATUS_TONES = {
  pending: 'warn',
  accepted: 'ok',
  rejected: 'danger',
};

/** The badge token for one offer status; unknown falls to neutral, never to a
 *  colour that would announce an outcome nobody defined. */
export const offerStatusTone = (status) =>
  OFFER_STATUS_TONES[String(status || '').trim().toLowerCase()] || 'neutral';

export const T = {
  ar: {
    tag: 'مَعبر · لوحة المورد', welcome: 'أهلاً،', desc: 'تابع عروضك ومنتجاتك ورسائلك من مكان واحد', supplierStageLabel: 'حالة الحساب', supplierIdLabel: 'معرّف مورد مَعبر',
    overview: 'نظرة عامة', myProducts: 'منتجاتي', offers: 'عروضي', addProduct: 'إضافة منتج',
    messages: 'الرسائل', settings: 'إعداداتي', offersCount: 'عروض مقدمة',
    productsCount: 'منتجات نشطة', messagesCount: 'رسائل جديدة',
    browseRequests: 'تصفح طلبات التجار', addNewProduct: 'إضافة منتج جديد',
    quickActions: 'الإجراءات السريعة', stats: 'الإحصائيات', backHome: 'العودة للرئيسية ←', back: 'رجوع ←',
    myOffers: 'عروضي', noOffers: 'ما قدمت عروض بعد', browseReqs: 'تصفح الطلبات',
    trackingPrompt: 'أدخل رقم التتبع لإخطار التاجر', trackingNum: 'رقم التتبع', send: 'إرسال',
    contactTrader: 'تواصل مع التاجر', tracking: 'رقم التتبع:',
    messagesTitle: 'الرسائل', noMessages: 'ما عندك رسائل بعد',
    addProductTitle: 'إضافة منتج جديد', myProductsTitle: 'منتجاتي', noProducts: 'ما أضفت منتجات بعد',
    nameAr: 'اسم المنتج بالعربي', nameEn: 'اسم المنتج بالإنجليزي *', nameZh: 'اسم المنتج بالصيني *',
    category: 'التصنيف', currency: 'العملة', price: 'السعر الابتدائي *', moq: 'MOQ *', descLabel: 'الوصف بالعربي', descEnLabel: 'الوصف بالإنجليزي *', descHint: 'العربي اختياري، والإنجليزي هو الأساس لعرض المنتج وترجمته لاحقًا.',
    save: 'حفظ', cancel: 'إلغاء', saving: '...',
    edit: 'تعديل', delete: 'حذف', confirmDelete: 'هل تبي تحذف هذا المنتج؟',
    active: 'نشط', inactive: 'موقوف', toggleActive: 'تفعيل/إيقاف',
    needsAttention: 'يحتاج انتباهك', acceptedOffer: 'عرض مقبول — تواصل مع التاجر',
    offerRejected: 'تم رفض عرضك على',
    uploadImage: 'رفع صورة', uploadVideo: 'رفع فيديو',
    uploadingImage: 'جاري رفع الصورة...', uploadingVideo: 'جاري رفع الفيديو...',
    imageUploaded: 'تم رفع الصورة', videoUploaded: 'تم رفع الفيديو', maxVideo: 'الحد الأقصى للفيديو 200MB',
    galleryImages: 'صور المنتج', addMoreImages: 'إضافة صور أخرى', galleryHint: 'حتى 8 صور — الصورة الأولى هي الرئيسية حالياً', maxImagesReached: 'وصلت للحد الأقصى (8 صور)', maxImagesError: 'يمكن رفع 8 صور كحد أقصى', removeMedia: 'حذف', previewStep: 'معاينة قبل النشر', continueToPreview: 'متابعة للمعاينة', backToEdit: 'رجوع للتعديل', publishNow: 'نشر المنتج', previewNote: 'راجع الوسائط والمواصفات والسعر قبل النشر. العملة المعروضة هنا لا تغيّر عملة المنتج الأصلية.', previewBadge: 'معاينة', previewEmptyMedia: 'ما تمت إضافة صور بعد', primaryImage: 'الصورة الرئيسية', videoLimitHint: 'فيديو واحد فقط لكل منتج',
    specsTitle: 'مواصفات المنتج', specMaterial: 'الخامة / المادة', specDimensions: 'الأبعاد / المقاس', specWeight: 'وزن القطعة', specColors: 'الألوان أو الخيارات', specPackaging: 'تفاصيل التغليف', specCustomization: 'التخصيص / OEM', specLeadTime: 'مدة التجهيز (أيام)', productSavedWithFallback: 'تم حفظ المنتج، لكن بعض الحقول الجديدة تحتاج تفعيل قاعدة البيانات حتى تُحفظ بالكامل.',
    sampleSettings: 'إعدادات العينة', sampleAvailable: 'متاح للعينة',
    samplePrice: 'سعر العينة (ريال)', sampleShipping: 'تكلفة الشحن (ريال)',
    sampleMaxQty: 'الحد الأقصى للكمية', sampleNote: 'ملاحظة للعينة',
    settingsTitle: 'إعدادات الحساب', companyName: 'اسم الشركة',
    bioAr: 'وصف الشركة بالعربي', bioEn: 'وصف الشركة بالإنجليزي', bioZh: 'وصف الشركة بالصيني',
    whatsapp: 'واتساب', wechat: 'WeChat', city: 'المدينة', country: 'الدولة',
    tradeLink: 'رابط صفحة المتجر / الملف التجاري', speciality: 'تخصص الشركة', minOrder: 'الحد الأدنى لقيمة الطلب (ريال)',
    logo: 'لوقو / صورة الشركة', factoryImages: 'صور المصنع (حتى 3)',
    uploadLogo: 'رفع اللوقو', uploadFactory: 'إضافة صورة', uploadingLogo: 'جاري الرفع...',
    saveSettings: 'حفظ الإعدادات', settingsSaved: 'تم حفظ التغييرات', saveAndContinue: 'احفظ وانتقل للخطوة التالية', verificationReviewRequired: 'افتح خطوة المراجعة النهائية قبل إرسال طلب التحقق.', days: 'يوم',
    verificationTab: 'ملف الاستلام', verificationTitle: 'أكمل التحقق التجاري', verificationIntro: 'أرسل بيانات التحقق والمستندات من هنا بعد إنشاء الحساب. لن نطلبها في التسجيل الأولي.',
    verificationStatusIncomplete: 'التحقق غير مكتمل', verificationStatusComplete: 'تم إرسال التحقق للمراجعة', verificationStatusLocked: 'الحساب الآن تحت المراجعة',
    verificationCtaTitle: 'أكمل التحقق التجاري', verificationCtaBody: 'أرسل السجل التجاري وصورة المصنع وبيانات الخبرة حتى يدخل طلبك مرحلة المراجعة.', verificationCtaAction: 'أكمل التحقق ←',
    uploadProductsBannerTitle: 'حسابك قيد المراجعة — ابدأ برفع منتجاتك الآن', uploadProductsBannerBody: 'بعد القبول، ستظهر منتجاتك فوراً للتجار السعوديين. ارفعها الآن وكن جاهزاً من اليوم الأول.', uploadProductsBannerAction: 'ارفع منتجاتك الآن ←',
    legalRepIdLabel: 'هوية الممثل القانوني', addressProofLabel: 'إثبات عنوان المصنع', verificationPrivacyNote: 'ملفاتك محفوظة بشكل خاص ولن تُشارك علنياً. البيانات البنكية ستُجمع بعد القبول.',
    onbWelcomeTitle: 'تهانينا، تم قبولك!', onbWelcomeIntro: 'حسابك الآن موثّق على معبر. لنكمل آخر خطوات الإعداد قبل أن تستقبل طلبات التجار.', onbWelcomeBtn: 'ابدأ الإعداد ←',
    onbProfileTitle: 'أكمل ملف الشركة', onbProfileFieldDescription: 'وصف الشركة', onbProfileFieldBusinessType: 'نوع النشاط', onbProfileFieldYearEstablished: 'سنة التأسيس', onbProfileFieldNumEmployees: 'عدد الموظفين', onbProfileFieldExportMarkets: 'أسواق التصدير', onbProfileFieldExportMarketsHint: 'افصل بين الأسواق بفاصلة (مثال: السعودية، الإمارات، الأردن).', onbProfileFieldCertifications: 'شهادات الجودة', onbProfileFieldCertificationsHint: 'سطر واحد لكل شهادة (مثال: ISO 9001).', onbProfileFieldWebsite: 'موقع الشركة', onbSaveContinueBtn: 'حفظ ومتابعة', onbSavingError: 'تعذر الحفظ. حاول مرة أخرى.',
    onbBankTitle: 'أضف بيانات الاستلام', onbBankNote: 'بياناتك البنكية مشفرة وتُستخدم فقط لتحويل المدفوعات إليك.', onbBankFieldBeneficiary: 'اسم المستفيد', onbBankFieldBankName: 'اسم البنك', onbBankFieldAccountNumber: 'رقم الحساب', onbBankFieldSwift: 'رمز SWIFT', onbBankFieldIban: 'IBAN (اختياري)', onbBankFieldCurrency: 'العملة المفضلة للعرض', onbBankSkipLink: 'أكمل لاحقاً', onbBankRequiredError: 'أكمل اسم المستفيد، اسم البنك، رقم الحساب، ورمز SWIFT، أو اضغط على "أكمل لاحقاً".',
    onbReadyTitle: 'أنت جاهز! ابدأ برفع منتجاتك', onbReadyBody: 'منتجاتك ستكون جاهزة للتجار السعوديين فور الإطلاق الرسمي للمنصة.', onbReadyPrimaryBtn: 'رفع أول منتج', onbReadySecondaryBtn: 'تصفح طلبات التجار',
    regNumber: 'رقم تسجيل الشركة *', yearsExp: 'سنوات الخبرة *', employees: 'عدد الموظفين (اختياري)', businessLicense: 'رخصة الأعمال أو هوية المنشأة *', factoryPhoto: 'صورة المصنع أو المستودع *', replaceFile: 'استبدال الملف', viewCurrentFile: 'عرض الملف الحالي', secureStorageNote: 'يتم حفظ هذه الملفات داخل تخزين خاص، ولا تُعرض بروابط عامة.', verificationSubmitted: 'تم إرسال التحقق بنجاح. الحساب الآن تحت المراجعة.', verificationMissing: 'يرجى تعبئة جميع حقول التحقق المطلوبة ورفع المستندات.', verificationVideoRequired: 'يرجى رفع مقطع فيديو للمصنع قبل إرسال التحقق.', verificationProfileRequired: 'أكمل أولاً بيانات الشركة الأساسية واحفظها قبل إرسال التحقق.',
    payoutTab: 'المدفوعات', payoutTitle: 'إعدادات استلام الدفعات', payoutIntro: 'أضف بياناتك البنكية لتكون جاهزًا لاستقبال الدفعات مستقبلًا عبر معبر.', payoutNote: 'يتم حفظ هذه البيانات بشكل آمن.', payoutLocked: 'إعدادات الدفعات تفتح بعد الموافقة على حسابك.', payoutCtaTitle: 'أكمل بيانات الدفعات', payoutCtaBody: 'حسابك مقبول، لكن بياناتك البنكية ما زالت غير مكتملة.', payoutCtaAction: 'إكمال بيانات الدفعات ←', payoutSaved: 'تم حفظ بيانات الدفعات', payoutReassurance: 'بياناتك البنكية تُستخدم فقط لاستلام المدفوعات. مَعبر لن يخصم أي مبلغ منك.', beneficiaryName: 'اسم المستفيد', bankName: 'اسم البنك', bankAccountNumber: 'رقم الحساب البنكي', swiftCode: 'SWIFT / BIC', bankAddress: 'عنوان البنك', preferredCurrency: 'العملة المفضلة', branchNameOptional: 'اسم الفرع (اختياري)', ibanOptional: 'IBAN (اختياري)', savePayout: 'حفظ بيانات الدفعات', onboardingTitle: 'حسابك فعّال — التوثيق ما زال قيد الإكمال', onboardingBody: 'يمكنك الآن إضافة المنتجات واستقبال طلبات التجّار وإرسال العروض والمراسلة. التوثيق يفتح استلام المدفوعات ويضيف شارة الموثّق إلى ملفك.', onboardingProgress: 'تقدّم الطلب', onboardingLockedTitle: 'ما الذي يفتحه التوثيق', onboardingLockedBody: 'المقفل هو استلام المدفوعات فقط: لا يمكنك استلام الأموال قبل اعتماد التحقق. أمّا المنتجات والعروض والرسائل وطلبات التجّار فمتاحة لك الآن.', onboardingStepApply: '1) أكمل الملف الأساسي', onboardingStepReview: '2) أرسل التحقق للمراجعة', onboardingStepVisibility: '3) اعتماد التحقق لاستلام المدفوعات', onboardingGoSettings: 'إعدادات الملف', onboardingVerificationReady: 'بعد إرسال التحقق ينتقل الحساب مباشرة إلى مرحلة المراجعة.', verificationSubmitAction: 'إرسال التحقق',
    tieredPricingTitle: 'التسعير المتدرج *',
    tieredPricingHint: 'الشريحة 1 مطلوبة. الشريحتان 2 و3 اختياريتان: أضفهما إذا كان السعر ينخفض مع زيادة الكمية.',
    tierColTier: 'الشريحة', tierColMinQty: 'أقل كمية', tierColMaxQty: 'أقصى كمية', tierColUnitPrice: 'سعر الوحدة',
    tierLabel: (n) => `الشريحة ${n}`,
    tierAndAbove: 'وأكثر',
    tierAutoFromMoq: 'يبدأ من MOQ تلقائياً (يمكن التعديل)',
    tierPriceRange: (lo, hi, currency) => `${lo}–${hi} ${currency} / وحدة`,
    moqValidationMin: 'الحد الأدنى للكمية يجب أن يكون رقماً صحيحاً ≥ 1.',
    composerRequiredFields: 'يرجى تعبئة: الاسم الصيني، الاسم الإنجليزي، الوصف الإنجليزي، MOQ، والشرائح السعرية الثلاث.',
    tierValidationCount: 'أدخل سعر الوحدة للشريحة 1 على الأقل.',
    tierValidationGap: (n) => `الشريحة ${n}: عبّئ الشريحة ${n - 1} أولاً.`,
    tierValidationNumeric: (n) => `الشريحة ${n}: أدخل قيماً رقمية صحيحة.`,
    tierValidationQtyFromMissing: (n) => `الشريحة ${n}: أدخل أقل كمية.`,
    tierValidationQtyToMissing: (n) => `الشريحة ${n}: أدخل أقصى كمية.`,
    tierValidationPriceMissing: (n) => `الشريحة ${n}: أدخل سعر الوحدة.`,
    tierValidationQtyFromMin: (n) => `الشريحة ${n}: أقل كمية يجب أن تكون 1 على الأقل.`,
    tierValidationPricePositive: (n) => `الشريحة ${n}: سعر الوحدة يجب أن يكون أكبر من صفر.`,
    tierValidationQtyOrder: (n) => `الشريحة ${n}: أقصى كمية يجب أن تكون أكبر من أقل كمية.`,
    tierValidationOverlap: (n) => `الشريحة ${n}: نطاق الكمية متداخل مع الشريحة السابقة.`,
    tierValidationDescending: (n) => `الشريحة ${n}: سعر الوحدة يجب أن يكون أقل من الشريحة السابقة.`,
    tiersStillLoading: 'جاري تحميل الأسعار الحالية… انتظر لحظة ثم احفظ.',
    tierSaveFailed: 'تم حفظ المنتج لكن تعذّر حفظ السعر. افتح المنتج وأعد إدخال السعر ثم احفظ.',
    noPriceBadge: 'بدون سعر',
    addYourPrice: 'أضف سعرك',
    noPriceHint: 'المنتجات بدون سعر تظهر بعد المنتجات المسعّرة في الكتالوج والصفحة الرئيسية.',
    secMedia: 'الوسائط',
    secBasicInfo: 'المعلومات الأساسية',
    secPricing: 'التسعير والشحن',
    secSpecs: 'المواصفات والتغليف',
    secCertifications: 'الشهادات والامتثال',
    secSamples: 'العينات والتخصيص',
    sectionBadgeAllDone: 'مكتمل',
    sectionBadgeOptional: 'اختياري',
    sectionBadgeProgress: (done, total) => `${done} من ${total} مطلوبة`,
    hsCodeLabel: 'رمز التعريفة الجمركية (HS Code)',
    hsCodeHint: 'اقتراحات الذكاء الاصطناعي قريبًا',
    hsCodePlaceholder: 'مثال: 8517.62.00',
    countryOfOriginLabel: 'بلد المنشأ',
    countryChina: 'الصين',
    countryVietnam: 'فيتنام',
    countryTurkey: 'تركيا',
    countryIndia: 'الهند',
    countryPakistan: 'باكستان',
    countryBangladesh: 'بنغلاديش',
    countryIndonesia: 'إندونيسيا',
    countryOther: 'أخرى',
    countryOtherPlaceholder: 'حدد البلد',
    incotermsLabel: 'شروط الشحن (Incoterms) *',
    incotermsHint: 'حدد كل ما ينطبق',
    incotermFob: 'FOB',
    incotermCif: 'CIF',
    incotermExw: 'EXW',
    incotermDdp: 'DDP',
    ddpTooltip: 'يتطلب وسيط جمركي في السعودية.',
    incotermsValidation: 'اختر شرط شحن واحدًا على الأقل.',
    portOfLoadingLabel: 'ميناء الشحن *',
    portShanghai: 'شانغهاي',
    portShenzhen: 'شنجن',
    portNingbo: 'نينغبو',
    portGuangzhou: 'قوانغتشو',
    portQingdao: 'تشينغداو',
    portTianjin: 'تيانجين',
    portOther: 'أخرى',
    portOtherPlaceholder: 'حدد الميناء',
    portValidation: 'اختر ميناء الشحن.',
    priceValidityLabel: 'مدة سريان السعر',
    priceValidity30: '30 يومًا',
    priceValidity60: '60 يومًا',
    priceValidity90: '90 يومًا',
    leadTimeSection: 'مدة التصنيع',
    leadTimeMin: 'الحد الأدنى (أيام)',
    leadTimeMax: 'الحد الأقصى (أيام)',
    leadTimeNegotiable: 'قابل للتفاوض للطلبات الكبيرة',
    leadTimeOrderError: 'الحد الأقصى لمدة التصنيع يجب أن يكون أكبر من أو يساوي الحد الأدنى.',
    unitsPerCartonLabel: 'عدد الوحدات في الكرتون',
    cbmLabel: 'CBM (متر³ لكل كرتون)',
    cbmCalcBtn: 'احسب من أبعاد الكرتون',
    cbmCalcMissingDims: 'أدخل أبعاد الكرتون أولًا (مثال: 60×40×30 سم).',
    cbmCalcParseFail: 'تعذر قراءة الأبعاد. تأكد من الصيغة (مثال: 60×40×30 سم).',
    grossWeightLabel: 'الوزن الإجمالي (كجم)',
    netWeightLabel: 'الوزن الصافي (كجم)',
    certificationsTitle: 'الشهادات والامتثال',
    certificationsHint: 'أضف SASO وCE وFCC وISO وغيرها (الرفع الفعلي يأتي في المرحلة التالية).',
    certComingSoon: 'إمكانية رفع الشهادات قريبًا',
    oemAvailableLabel: 'متاح OEM (علامة المشتري)',
    odmAvailableLabel: 'متاح ODM (تصميم مخصص)',
    oemHint: 'OEM يعني شعارك على منتج جاهز. ODM يعني تصميم خاص نهندسه لك.',
    oemLeadTimeSection: 'مدة OEM/ODM',
    oemLeadTimeMin: 'الحد الأدنى (أيام)',
    oemLeadTimeMax: 'الحد الأقصى (أيام)',
    completenessRequired: 'الحقول المطلوبة',
    completenessRecommended: 'الحقول الموصى بها',
    completenessMedia: 'الوسائط (3 صور وفيديو واحد على الأقل)',
    completenessCerts: 'شهادة واحدة على الأقل',
    // Phase 4 — certifications uploader
    certAddBtn: '+ إضافة شهادة',
    certTypeLabel: 'نوع الشهادة',
    certNameLabel: 'اسم الشهادة',
    certNameHint: 'مطلوب عند اختيار "أخرى"',
    certIssuedDateLabel: 'تاريخ الإصدار',
    certExpiryDateLabel: 'تاريخ الانتهاء',
    certUploadFile: 'رفع PDF',
    certReplaceFile: 'استبدال',
    certUploaded: 'تم الرفع',
    certViewFile: 'عرض الملف',
    certRemoveBtn: 'حذف',
    certNoneYet: 'لم تتم إضافة أي شهادة بعد.',
    certPdfOnly: 'يجب أن يكون الملف بصيغة PDF فقط.',
    certTooLarge: 'حجم الملف أكبر من 10 ميجابايت.',
    certPickTypeFirst: 'اختر نوع الشهادة أولاً.',
    certMaxReachedFn: (n) => `الحد الأقصى ${n} شهادات.`,
    // Phase 4 — HS code AI suggester
    hsCodeSuggestBtn: 'اقتراح رمز HS بالذكاء الاصطناعي',
    hsCodeSuggesting: 'جارٍ الاقتراح…',
    hsCodeSuggestNoName: 'أدخل اسم المنتج بالإنجليزي أولاً.',
    hsCodeSuggestEmpty: 'لا توجد اقتراحات.',
    hsCodeSuggestFailed: 'تعذّر الحصول على اقتراحات. حاول لاحقاً.',
    hsCodeSuggestionsTitle: 'اقتراحات الذكاء الاصطناعي',
    // Phase 4 — i18n cleanup (was inline ternary)
    attrNamePlaceholder: 'اسم الخاصية (مثال: اللون)',
    attrValuePlaceholder: 'اكتب قيمة واضغط Enter',
    attrAddBtn: 'إضافة',
    attributesTitle: 'الخصائص المخصصة',
    attributesAddBtn: '+ إضافة خاصية',
    attributesEmptyHint: 'أضف خصائص مثل: اللون، الحجم، الجهد الكهربائي…',
    specUnitWeightKg: 'وزن الوحدة (كجم)',
    specCartonDimensions: 'أبعاد الكرتون',
    sampleFreeFromQtyLabel: 'عينة مجانية من (وحدة)',
    variantToggleTitle: 'هذا المنتج له خيارات متعددة (ألوان، أحجام…)',
    variantToggleHint: 'فعّل لإضافة ألوان وأحجام مع تسعير مستقل لكل تركيبة',
    readinessTitle: 'جاهزية النشر التجارية',
    previewListingReadiness: 'جاهزية العرض',
    previewReadinessSummaryFn: (pct, done, total) => `${pct}٪ جاهز للنشر (${done}/${total})`,
    previewImageCountFn: (n) => `${n} صور`,
    previewSpecsCountFn: (n) => `${n} مواصفات`,
    previewSamplesEnabled: 'عينة مفعلة',
    previewDisplayedNames: 'الأسماء المعروضة',
    previewNameZhLabel: 'الاسم الصيني',
    previewNameEnLabel: 'الاسم الإنجليزي',
    previewNameArLabel: 'الاسم العربي',
    previewCustomAttributes: 'الخصائص المخصصة',
    // Phase 4 — validation polish
    cbmPositiveError: 'CBM يجب أن يكون أكبر من صفر.',
    weightPositiveError: 'الوزن يجب أن يكون أكبر من صفر.',
    // Phase 5B — buyer-facing block titles & helpers
    buyerBlockPricingTitle: 'التسعير وشروط التجارة',
    buyerBlockComplianceTitle: 'الامتثال والشهادات',
    buyerBlockCustomizationTitle: 'التخصيص',
    buyerCurrencyLabel: 'العملة',
    buyerPriceValidityLabel: 'صلاحية السعر',
    priceValidDaysFn: (days) => `${days} يوماً`,
    buyerIncotermsLabel: 'شروط الشحن (Incoterms)',
    buyerPortOfLoadingLabel: 'ميناء الشحن',
    buyerLeadTimeLabel: 'مدة التصنيع',
    leadTimeBuyerFn: (min, max, negotiable) => {
      const core = min !== null && max !== null
        ? (min === max ? `${min}` : `${min}–${max}`)
        : `${min ?? max}`;
      return `${core} يوم${negotiable ? ' · قابل للتفاوض' : ''}`;
    },
    certSaudiReadyBadge: 'جاهز للسوق السعودي',
    certIssuedShort: 'الإصدار',
    certExpiresShort: 'الانتهاء',
    certDownloadPdf: 'تنزيل PDF',
    customizationContactHelper: 'تواصل مع المورد لمناقشة خيارات التخصيص.',
    buyerOemLeadTimeFn: (min, max) => {
      const core = min !== null && max !== null
        ? (min === max ? `${min}` : `${min}–${max}`)
        : `${min ?? max}`;
      return `${core} يوم`;
    },
    // Phase 5C — listing card chips
    cardMoqFn: (qty) => `MOQ: ${qty}`,
    cardLeadTimeFn: (min, max) => {
      const core = min !== null && max !== null
        ? (min === max ? `${min}` : `${min}–${max}`)
        : `${min ?? max}`;
      return `${core} يوم`;
    },
    // Phase 5D — buyer-facing logistics + HS code + supplier cert aggregate + order terms
    buyerBlockLogisticsTitle: 'اللوجستيات والشحن',
    buyerLogisticsHelper: 'استخدم هذه الأرقام مع وكيل الشحن لتقدير التكلفة الإجمالية حتى الوصول.',
    buyerHsCodeTooltip: 'رمز النظام المنسّق (HS) المستخدم في الإقرار الجمركي.',
    supplierCertsAggregateLabel: 'منتجات هذا المورد تحمل الشهادات التالية:',
    supplierCertifiedPill: 'حاصل على شهادات',
    // Phase 6A — buyer-facing supplier profile additions
    spFactoryPhotosLabel: 'صور المصنع',
    spProfileBeingSetup: 'هذا المورد يكمل إعداد ملفه. تابع لاحقاً للاطلاع على المنتجات والشهادات.',
    // Phase 6B — AI translation pill + toggle on supplier profile free-text fields
    spAiTranslated: 'ترجمة آلية',
    spShowOriginal: 'عرض الأصل',
    spShowTranslation: 'عرض الترجمة',
    spTranslationUnavailable: 'الترجمة غير متاحة',
    // Phase 6D — quality certifications multi-entry UI + buyer-facing cert links
    certAddBtn: '+ إضافة شهادة',
    certUploadBtn: 'رفع ملف',
    certUploadingLabel: 'جاري الرفع...',
    certReplaceBtn: 'استبدال',
    certUploadedLabel: 'تم الرفع',
    certUploadFailed: 'فشل الرفع',
    certFileTypesHint: 'PDF أو JPG أو PNG · حد أقصى 10 ميغابايت لكل ملف',
    certNamePlaceholder: 'مثال: ISO 9001',
    spViewCertificate: 'عرض الشهادة ←',
    buyerOrderTermsTitle: 'شروط التجارة',
    buyerOrderProductLabel: 'المنتج',
    buyerOrderEmpty: '—',
    // Phase 5D — ProductDetail buyer-visible strings (i18n cleanup)
    pdBackBtn: 'العودة',
    pdProductNotFound: 'المنتج غير موجود',
    pdVerifiedSupplierPill: 'مورد موثّق',
    pdSampleAvailablePill: 'عينة متاحة',
    pdAlternateNameFn: (name) => `اسم المصنع / الاسم البديل: ${name}`,
    pdOriginalPriceFn: (formatted) => `السعر الأصلي: ${formatted}`,
    pdPerUnit: 'وحدة',
    pdMinOrderLabel: 'الحد الأدنى للطلب',
    pdSupplierLabel: 'المورد',
    pdOriginLabel: 'بلد المنشأ',
    pdSampleLabel: 'العينة',
    pdSourcingSnapshotTitle: 'ملخص التوريد',
    pdSourcingSnapshotBody: 'هذه الصفحة تعرض معلومات أقرب لتوقعات المورد الصيني: MOQ، وقت التجهيز، العينات، والتخصيص، مع إشارات ثقة المورد قبل التواصل أو الطلب.',
    pdSourcingMoqLabel: 'الحد الأدنى للطلب',
    pdSourcingLeadTimeLabel: 'مدة التجهيز',
    pdSourcingCustomizationLabel: 'التخصيص',
    pdSourcingSamplesLabel: 'العينات',
    pdSourcingPackagingLabel: 'التغليف',
    pdLeadTimeDaysFn: (n) => `${n} يوم`,
    pdCustomizationNotSpecified: 'غير موضح',
    pdSamplesAvailableValue: 'متاحة',
    pdSamplesNotAvailableValue: 'غير متاحة',
    pdAttributesTitle: 'الخصائص',
    pdLoadingOptions: 'جاري تحميل الخيارات…',
    pdSelectOptions: 'اختر المواصفات',
    pdPriceLabel: 'السعر',
    pdStockLabel: 'المخزون',
    pdOutOfStock: 'نفد',
    pdSelectAllToSeePrice: 'اختر جميع الخيارات لعرض السعر',
    pdQuantity: 'الكمية',
    pdQuantityPlaceholder: 'مثال: 200',
    pdAddToOrder: '+ أضف إلى الطلب',
    pdOrderSummary: 'ملخص الطلب',
    pdNoVariantsAdded: 'لم تضف أي منتج بعد. اختر الخيارات وأضف الكمية.',
    pdQty: 'الكمية',
    pdUnit: 'سعر الوحدة',
    pdTotal: 'الإجمالي',
    pdRemove: 'إزالة',
    pdGrandTotalFn: (n) => `الإجمالي (${n} قطعة)`,
    pdRequestQuote: 'إرسال طلب عرض السعر ←',
    pdMaabarReviewLabel: 'مراجعة مَعبر',
    pdMaabarReviewYes: 'هذا المورد ظاهر للمشترين بعد مراجعة مَعبر.',
    pdMaabarReviewNo: 'مورّد معتمد',
    pdTrustSignalsLabel: 'دلائل الثقة',
    pdTrustTradeProfile: 'رابط الشركة متوفر',
    pdTrustNoTradeProfile: 'لا يوجد رابط شركة ظاهر',
    pdTrustWeChat: 'WeChat متاح',
    pdTrustFactoryMedia: 'صور منشأة متاحة',
    pdCommercialIdentityLabel: 'الهوية التجارية',
    pdSupplierIdFn: (id) => `معرّف المورد: ${id}`,
    pdSupplierIdMissing: 'معرّف المورد غير ظاهر بعد',
    pdYearsExperienceFn: (n) => `${n} سنة خبرة`,
    pdVerifiedShort: 'موثّق',
    pdReviewsCountFn: (n) => `${n} تقييم`,
    pdSupplierIdLabel: 'معرّف المورد',
    pdCompanyStoreLink: 'رابط الشركة / المتجر',
    pdCtaHelper: 'يمكنك الطلب مباشرة من هذه الصفحة أو مراسلة المورد أولاً لتأكيد التغليف، التخصيص، مدة التجهيز، أو الشحن.',
    pdBuyNowBtn: 'اشترِ الآن',
    pdRequestSampleFn: (price) => `اطلب عينة — ${price} SAR`,
    pdContactSupplierBtn: 'تواصل مع المورد',
    // Product page — mirrors the factory product page's two CTAs.
    pdQuoteCta: 'اطلب عرض سعر',
    pdMessageSupplierCta: 'راسل المورّد',
    pdMsgStarting: 'جارٍ الفتح…',
    pdQuoteNote: 'المورّد يرد بالسعر — لا حاجة لإدخال ميزانية.',
    pdZoomHint: 'اضغط للتكبير',
    pdDescLabel: 'الوصف',
    pdCustomizationLabel: 'خيارات التخصيص',
    pdOnRequest: 'عند الطلب',
    pdBuyModalTitle: 'أدخل الكمية',
    pdBuyModalQtyLabel: 'الكمية *',
    pdBuyModalNoteLabel: 'ملاحظة (اختياري)',
    pdBuyModalNotePlaceholder: 'مثلاً: التغليف، المواصفات النهائية، علامة خاصة...',
    pdBuyModalSigninWarning: '* سيُطلب منك تسجيل الدخول',
    pdBuyModalSubmit: 'إرسال الطلب ←',
    pdCancelBtn: 'إلغاء',
    pdOrderSentTitle: 'تم إرسال طلبك، بانتظار تأكيد المورد',
    pdOrderSentBody: 'سيؤكد المورد طلبك خلال 24 ساعة. عند التأكيد، ستصلك إشعار وستتمكن من الدفع لبدء التجهيز.',
    pdBackToProducts: 'العودة للمنتجات',
    pdViewMyOrders: 'عرض طلباتي',
    pdSampleModalTitle: 'طلب عينة',
    pdSampleModalSubtitleFn: (price, shipping) => `سعر الوحدة: ${price} ريال + شحن: ${shipping} ريال`,
    pdSampleBadge: 'عينة',
    pdSampleQtyLabelFn: (max) => `الكمية (الحد الأقصى ${max})`,
    pdSampleTotalLabel: 'الإجمالي',
    pdSampleNoteLabel: 'ملاحظة',
    pdSampleNotePlaceholder: 'اللون، المواصفات...',
    pdSampleModalSigninWarning: '* سيُطلب منك تسجيل الدخول عند الإرسال',
    pdSampleSubmit: 'إرسال طلب العينة ←',
    // Buyer-visible alert messages (kept in T-table per Phase 5D i18n rule)
    pdAlertSupplierNotFound: 'تعذّر تحديد المورد، حاول لاحقاً',
    pdAlertValidQuantity: 'يرجى تحديد كمية صحيحة',
    pdAlertSelectAllOptions: 'يرجى اختيار جميع الخيارات أولاً',
    pdAlertMinQtyFn: (qty) => `الحد الأدنى للطلب ${qty} قطعة`,
    pdAlertAddVariant: 'أضف منتجاً واحداً على الأقل إلى طلبك',
    pdAlertQuoteSent: '✅ تم إرسال طلب عرض السعر! سيتواصل معك المورد قريباً',
    pdAlertMaxSampleQtyFn: (max) => `الحد الأقصى للعينة ${max} قطع`,
    pdAlertSampleSent: '✅ تم إرسال طلب العينة! سيتواصل معك المورد قريباً',
    pdShippingOptionsTitle: 'خيارات الشحن',
    pdShipMethodSea: 'شحن بحري',
    pdShipMethodAir: 'شحن جوي',
    pdShipMethodExpress: 'شحن سريع',
    pdShipMethodLand: 'شحن بري',
  },
  en: {
    tag: 'Maabar · Supplier Dashboard', welcome: 'Welcome,', desc: 'Manage your offers, products and messages in one place', supplierStageLabel: 'Account status', supplierIdLabel: 'Maabar Supplier ID',
    overview: 'Overview', myProducts: 'My Products', offers: 'My Offers', addProduct: 'Add Product',
    messages: 'Messages', settings: 'Settings', offersCount: 'Offers Submitted',
    productsCount: 'Active Products', messagesCount: 'New Messages',
    browseRequests: 'Browse Trader Requests', addNewProduct: 'Add New Product',
    quickActions: 'Quick Actions', stats: 'Overview', backHome: '← Back to Home', back: '← Back',
    myOffers: 'My Offers', noOffers: 'No offers yet', browseReqs: 'Browse Requests',
    trackingPrompt: 'Enter tracking number to notify buyer', trackingNum: 'Tracking number', send: 'Send',
    contactTrader: 'Contact Trader', tracking: 'Tracking:',
    messagesTitle: 'Messages', noMessages: 'No messages yet',
    addProductTitle: 'Add New Product', myProductsTitle: 'My Products', noProducts: 'No products yet',
    nameAr: 'Arabic Name', nameEn: 'English Name *', nameZh: 'Chinese Name *',
    category: 'Category', currency: 'Currency', price: 'Starting Price *', moq: 'MOQ *', descLabel: 'Arabic Description', descEnLabel: 'English Description *', descHint: 'Arabic is optional. English is the main source for listing quality and later translation.',
    save: 'Save', cancel: 'Cancel', saving: '...',
    edit: 'Edit', delete: 'Delete', confirmDelete: 'Delete this product?',
    active: 'Active', inactive: 'Paused', toggleActive: 'Toggle',
    needsAttention: 'Needs Attention', acceptedOffer: 'Offer accepted — Contact trader',
    offerRejected: 'Your offer was rejected on',
    uploadImage: 'Upload Image', uploadVideo: 'Upload Video',
    uploadingImage: 'Uploading...', uploadingVideo: 'Uploading...',
    imageUploaded: 'Image uploaded', videoUploaded: 'Video uploaded', maxVideo: 'Max 200MB',
    galleryImages: 'Product Images', addMoreImages: 'Add More Images', galleryHint: 'Up to 8 images — the first image stays the primary cover', maxImagesReached: 'Maximum reached (8 images)', maxImagesError: 'You can upload up to 8 images', removeMedia: 'Remove', previewStep: 'Preview Before Publish', continueToPreview: 'Continue to Preview', backToEdit: 'Back to Edit', publishNow: 'Publish Product', previewNote: 'Review media, specs, and pricing before publishing. Display currency never replaces the saved source product currency.', previewBadge: 'Preview', previewEmptyMedia: 'No product images yet', primaryImage: 'Primary image', videoLimitHint: 'One product video only',
    specsTitle: 'Product Specifications', specMaterial: 'Material', specDimensions: 'Dimensions / Size', specWeight: 'Unit Weight', specColors: 'Colors / Variants', specPackaging: 'Packaging Details', specCustomization: 'Customization / OEM', specLeadTime: 'Lead Time (days)', productSavedWithFallback: 'Product saved, but some new fields still need the DB migration before they can persist fully.',
    sampleSettings: 'Sample Settings', sampleAvailable: 'Available for Sample',
    samplePrice: 'Sample Price (SAR)', sampleShipping: 'Shipping Cost (SAR)',
    sampleMaxQty: 'Max Sample Qty', sampleNote: 'Sample Note',
    settingsTitle: 'Account Settings', companyName: 'Company Name',
    bioAr: 'Description (Arabic)', bioEn: 'Description (English)', bioZh: 'Description (Chinese)',
    whatsapp: 'WhatsApp', wechat: 'WeChat', city: 'City', country: 'Country',
    tradeLink: 'Trade profile / storefront link', speciality: 'Specialty', minOrder: 'Minimum order value (SAR)',
    logo: 'Company Logo', factoryImages: 'Factory Images (up to 3)',
    uploadLogo: 'Upload Logo', uploadFactory: 'Add Image', uploadingLogo: 'Uploading...',
    saveSettings: 'Save Settings', settingsSaved: 'Changes saved', saveAndContinue: 'Save and move to step 2', verificationReviewRequired: 'Open the final review step before submitting verification.', days: 'days',
    verificationTab: 'Payout details', verificationTitle: 'Complete business verification', verificationIntro: 'Submit the full verification details and documents here after signup. They are no longer required during initial registration.',
    verificationStatusIncomplete: 'Verification incomplete', verificationStatusComplete: 'Verification submitted for review', verificationStatusLocked: 'Account is currently under review',
    verificationCtaTitle: 'Complete your business verification', verificationCtaBody: 'Submit your registration, factory evidence, and experience details so your application can enter review.', verificationCtaAction: 'Complete verification →',
    uploadProductsBannerTitle: 'Account under review — Start uploading your products now', uploadProductsBannerBody: 'Once approved, your products will be immediately visible to Saudi buyers. Upload now and be ready from day one.', uploadProductsBannerAction: 'Upload Products Now →',
    legalRepIdLabel: 'Legal Representative ID', addressProofLabel: 'Factory/Office Address Proof', verificationPrivacyNote: 'Your files are stored privately and never shared publicly. Bank details will be collected separately after approval.',
    onbWelcomeTitle: 'Congratulations, you have been approved!', onbWelcomeIntro: 'Your account is now verified on Maabar. Let us finish the last setup steps before buyer requests start coming in.', onbWelcomeBtn: 'Start Setup →',
    onbProfileTitle: 'Complete Company Profile', onbProfileFieldDescription: 'Company Description', onbProfileFieldBusinessType: 'Business Type', onbProfileFieldYearEstablished: 'Year Established', onbProfileFieldNumEmployees: 'Number of Employees', onbProfileFieldExportMarkets: 'Export Markets', onbProfileFieldExportMarketsHint: 'Separate markets with commas (e.g. Saudi Arabia, UAE, Jordan).', onbProfileFieldCertifications: 'Quality Certifications', onbProfileFieldCertificationsHint: 'One certification per line (e.g. ISO 9001).', onbProfileFieldWebsite: 'Company Website', onbSaveContinueBtn: 'Save & Continue', onbSavingError: 'Could not save. Please try again.',
    onbBankTitle: 'Add Payout Details', onbBankNote: 'Your bank details are encrypted and only used to transfer payments to you.', onbBankFieldBeneficiary: 'Beneficiary Name', onbBankFieldBankName: 'Bank Name', onbBankFieldAccountNumber: 'Account Number', onbBankFieldSwift: 'SWIFT Code', onbBankFieldIban: 'IBAN (optional)', onbBankFieldCurrency: 'Preferred Display Currency', onbBankSkipLink: 'Complete later', onbBankRequiredError: 'Please complete beneficiary name, bank name, account number, and SWIFT code — or click "Complete later".',
    onbReadyTitle: 'You are ready! Start uploading products', onbReadyBody: 'Your products will be ready for Saudi buyers when the platform officially launches.', onbReadyPrimaryBtn: 'Upload First Product', onbReadySecondaryBtn: 'Browse Buyer Requests',
    regNumber: 'Company Registration Number *', yearsExp: 'Years of Experience *', employees: 'Number of Employees (optional)', businessLicense: 'Business License or Company ID *', factoryPhoto: 'Factory or Warehouse Photo *', replaceFile: 'Replace file', viewCurrentFile: 'View current file', secureStorageNote: 'These files are stored in private storage and are never exposed through public URLs.', verificationSubmitted: 'Verification submitted successfully. Your account is now under review.', verificationMissing: 'Please complete all required verification fields and upload the required documents.', verificationVideoRequired: 'Please upload at least one factory video before submitting verification.', verificationProfileRequired: 'Complete and save the basic company profile before submitting verification.',
    payoutTab: 'Payout', payoutTitle: 'Payout settings', payoutIntro: 'Add your bank details so you are ready to receive future payouts through Maabar.', payoutNote: 'This information is stored securely.', payoutLocked: 'Payout details unlock after your account is approved.', payoutCtaTitle: 'Complete your payout details', payoutCtaBody: 'Your account is approved, but your bank payout details are still incomplete.', payoutCtaAction: 'Add payout details →', payoutSaved: 'Payout details saved', payoutReassurance: 'Your bank details are only used to receive payments. Maabar will never charge you.', beneficiaryName: 'Beneficiary Name', bankName: 'Bank Name', bankAccountNumber: 'Bank Account Number', swiftCode: 'SWIFT / BIC', bankAddress: 'Bank Address', preferredCurrency: 'Preferred Currency', branchNameOptional: 'Branch Name (optional)', ibanOptional: 'IBAN (optional)', savePayout: 'Save payout details', onboardingTitle: 'Your account is active — verification is still pending', onboardingBody: 'You can already list products, receive trader requests, send offers and message buyers. Completing verification is what unlocks payout, and it adds the verified badge to your profile.', onboardingProgress: 'Application progress', onboardingLockedTitle: 'What verification unlocks', onboardingLockedBody: 'Only payout is locked: you cannot receive payments until verification is approved. Products, offers, messages and trader requests are open to you now.', onboardingStepApply: '1) Complete the basic profile', onboardingStepReview: '2) Submit verification for review', onboardingStepVisibility: '3) Get approved to receive payouts', onboardingGoSettings: 'Profile settings', onboardingVerificationReady: 'Once you submit verification, the account moves directly into review.', verificationSubmitAction: 'Submit verification',
    tieredPricingTitle: 'Tiered Pricing *',
    tieredPricingHint: 'Tier 1 is required. Tiers 2 and 3 are optional: add them if the price drops as the quantity grows.',
    tierColTier: 'Tier', tierColMinQty: 'Min Qty', tierColMaxQty: 'Max Qty', tierColUnitPrice: 'Unit Price',
    tierLabel: (n) => `Tier ${n}`,
    tierAndAbove: 'And above',
    tierAutoFromMoq: 'Starts from MOQ (editable)',
    tierPriceRange: (lo, hi, currency) => `${lo}–${hi} ${currency} / unit`,
    moqValidationMin: 'MOQ must be a whole number ≥ 1.',
    composerRequiredFields: 'Please fill: Chinese name, English name, English description, MOQ, and the three pricing tiers.',
    tierValidationCount: 'Enter at least the tier 1 unit price.',
    tierValidationGap: (n) => `Tier ${n}: fill tier ${n - 1} first.`,
    tierValidationNumeric: (n) => `Tier ${n}: enter valid numeric values.`,
    tierValidationQtyFromMissing: (n) => `Tier ${n}: enter the minimum quantity.`,
    tierValidationQtyToMissing: (n) => `Tier ${n}: enter the maximum quantity.`,
    tierValidationPriceMissing: (n) => `Tier ${n}: enter the unit price.`,
    tierValidationQtyFromMin: (n) => `Tier ${n}: minimum quantity must be at least 1.`,
    tierValidationPricePositive: (n) => `Tier ${n}: unit price must be greater than 0.`,
    tierValidationQtyOrder: (n) => `Tier ${n}: max quantity must be greater than min quantity.`,
    tierValidationOverlap: (n) => `Tier ${n}: quantity range overlaps the previous tier.`,
    tierValidationDescending: (n) => `Tier ${n}: unit price must be lower than the previous tier.`,
    tiersStillLoading: 'Loading the current prices… wait a moment, then save.',
    tierSaveFailed: 'The product was saved but its price could not be. Open the product, enter the price again and save.',
    noPriceBadge: 'No price',
    addYourPrice: 'Add your price',
    noPriceHint: 'Products without a price rank below priced ones in the catalog and on the home page.',
    secMedia: 'Media',
    secBasicInfo: 'Basic Information',
    secPricing: 'Pricing & Shipping',
    secSpecs: 'Specs & Packaging',
    secCertifications: 'Certifications & Compliance',
    secSamples: 'Samples & Customization',
    sectionBadgeAllDone: 'All set',
    sectionBadgeOptional: 'Optional',
    sectionBadgeProgress: (done, total) => `${done} of ${total} required`,
    hsCodeLabel: 'HS Code',
    hsCodeHint: 'AI suggestions coming soon',
    hsCodePlaceholder: 'e.g. 8517.62.00',
    countryOfOriginLabel: 'Country of Origin',
    countryChina: 'China',
    countryVietnam: 'Vietnam',
    countryTurkey: 'Türkiye',
    countryIndia: 'India',
    countryPakistan: 'Pakistan',
    countryBangladesh: 'Bangladesh',
    countryIndonesia: 'Indonesia',
    countryOther: 'Other',
    countryOtherPlaceholder: 'Specify country',
    incotermsLabel: 'Incoterms *',
    incotermsHint: 'Select all that apply',
    incotermFob: 'FOB',
    incotermCif: 'CIF',
    incotermExw: 'EXW',
    incotermDdp: 'DDP',
    ddpTooltip: 'Requires customs broker in Saudi Arabia.',
    incotermsValidation: 'Select at least one Incoterm.',
    portOfLoadingLabel: 'Port of Loading *',
    portShanghai: 'Shanghai',
    portShenzhen: 'Shenzhen',
    portNingbo: 'Ningbo',
    portGuangzhou: 'Guangzhou',
    portQingdao: 'Qingdao',
    portTianjin: 'Tianjin',
    portOther: 'Other',
    portOtherPlaceholder: 'Specify port',
    portValidation: 'Select a port of loading.',
    priceValidityLabel: 'Price Validity',
    priceValidity30: '30 days',
    priceValidity60: '60 days',
    priceValidity90: '90 days',
    leadTimeSection: 'Production Lead Time',
    leadTimeMin: 'Min (days)',
    leadTimeMax: 'Max (days)',
    leadTimeNegotiable: 'Negotiable for large orders',
    leadTimeOrderError: 'Lead time max must be ≥ min.',
    unitsPerCartonLabel: 'Units per Carton',
    cbmLabel: 'CBM (m³ per carton)',
    cbmCalcBtn: 'Calculate from carton dimensions',
    cbmCalcMissingDims: 'Enter carton dimensions first (e.g. 60×40×30 cm).',
    cbmCalcParseFail: 'Could not parse dimensions. Use format like 60×40×30 cm.',
    grossWeightLabel: 'Gross Weight (kg)',
    netWeightLabel: 'Net Weight (kg)',
    certificationsTitle: 'Certifications & Compliance',
    certificationsHint: 'Add SASO, CE, FCC, ISO, etc. (uploader coming next phase).',
    certComingSoon: 'Certificate upload available soon',
    oemAvailableLabel: 'OEM Available (your branding)',
    odmAvailableLabel: 'ODM Available (custom design)',
    oemHint: 'OEM = your branding on an existing product. ODM = custom design we engineer for you.',
    oemLeadTimeSection: 'OEM/ODM Lead Time',
    oemLeadTimeMin: 'Min (days)',
    oemLeadTimeMax: 'Max (days)',
    completenessRequired: 'Required fields',
    completenessRecommended: 'Recommended fields',
    completenessMedia: 'Media (3+ images and 1 video)',
    completenessCerts: 'At least 1 certification',
    // Phase 4 — certifications uploader
    certAddBtn: '+ Add Certification',
    certTypeLabel: 'Certificate Type',
    certNameLabel: 'Certificate Name',
    certNameHint: 'Required when type is "Other"',
    certIssuedDateLabel: 'Issued',
    certExpiryDateLabel: 'Expires',
    certUploadFile: 'Upload PDF',
    certReplaceFile: 'Replace',
    certUploaded: 'Uploaded',
    certViewFile: 'View file',
    certRemoveBtn: 'Remove',
    certNoneYet: 'No certifications added yet.',
    certPdfOnly: 'Only PDF files are accepted.',
    certTooLarge: 'PDF must be ≤ 10 MB.',
    certPickTypeFirst: 'Choose a certificate type first.',
    certMaxReachedFn: (n) => `Maximum ${n} certifications.`,
    // Phase 4 — HS code AI suggester
    hsCodeSuggestBtn: 'Suggest HS Code (AI)',
    hsCodeSuggesting: 'Suggesting…',
    hsCodeSuggestNoName: 'Enter the English product name first.',
    hsCodeSuggestEmpty: 'No suggestions returned.',
    hsCodeSuggestFailed: 'Could not get AI suggestions. Try again later.',
    hsCodeSuggestionsTitle: 'AI suggestions',
    // Phase 4 — i18n cleanup (was inline ternary)
    attrNamePlaceholder: 'Attribute name (e.g. Color)',
    attrValuePlaceholder: 'Type a value, press Enter',
    attrAddBtn: 'Add',
    attributesTitle: 'Custom Attributes',
    attributesAddBtn: '+ Add attribute',
    attributesEmptyHint: 'Add custom attributes like Color, Size, Wattage, etc.',
    specUnitWeightKg: 'Unit weight (kg)',
    specCartonDimensions: 'Carton dimensions',
    sampleFreeFromQtyLabel: 'Free sample from qty',
    variantToggleTitle: 'This product has multiple options / variants',
    variantToggleHint: 'Enable to set up colors, sizes, and per-variant pricing',
    readinessTitle: 'Publishing readiness',
    previewListingReadiness: 'Listing readiness',
    previewReadinessSummaryFn: (pct, done, total) => `${pct}% publish-ready (${done}/${total})`,
    previewImageCountFn: (n) => `${n} images`,
    previewSpecsCountFn: (n) => `${n} specs`,
    previewSamplesEnabled: 'Samples enabled',
    previewDisplayedNames: 'Displayed names',
    previewNameZhLabel: 'Chinese name',
    previewNameEnLabel: 'English name',
    previewNameArLabel: 'Arabic name',
    previewCustomAttributes: 'Custom Attributes',
    // Phase 4 — validation polish
    cbmPositiveError: 'CBM must be greater than 0.',
    weightPositiveError: 'Weight must be greater than 0.',
    // Phase 5B — buyer-facing block titles & helpers
    buyerBlockPricingTitle: 'Pricing & Trade Terms',
    buyerBlockComplianceTitle: 'Compliance & Certifications',
    buyerBlockCustomizationTitle: 'Customization',
    buyerCurrencyLabel: 'Currency',
    buyerPriceValidityLabel: 'Price Validity',
    priceValidDaysFn: (days) => `Valid for ${days} days`,
    buyerIncotermsLabel: 'Incoterms',
    buyerPortOfLoadingLabel: 'Port of Loading',
    buyerLeadTimeLabel: 'Production Lead Time',
    leadTimeBuyerFn: (min, max, negotiable) => {
      const core = min !== null && max !== null
        ? (min === max ? `${min}` : `${min}–${max}`)
        : `${min ?? max}`;
      return `${core} days${negotiable ? ' · Negotiable' : ''}`;
    },
    certSaudiReadyBadge: 'Saudi-ready',
    certIssuedShort: 'Issued',
    certExpiresShort: 'Expires',
    certDownloadPdf: 'Download PDF',
    customizationContactHelper: 'Contact the supplier to discuss customization options.',
    buyerOemLeadTimeFn: (min, max) => {
      const core = min !== null && max !== null
        ? (min === max ? `${min}` : `${min}–${max}`)
        : `${min ?? max}`;
      return `${core} days`;
    },
    // Phase 5C — listing card chips
    cardMoqFn: (qty) => `MOQ: ${qty}`,
    cardLeadTimeFn: (min, max) => {
      const core = min !== null && max !== null
        ? (min === max ? `${min}` : `${min}–${max}`)
        : `${min ?? max}`;
      return `${core} days`;
    },
    // Phase 5D — buyer-facing logistics + HS code + supplier cert aggregate + order terms
    buyerBlockLogisticsTitle: 'Logistics & Shipping',
    buyerLogisticsHelper: 'Share these with your freight forwarder to estimate landed cost.',
    buyerHsCodeTooltip: 'Harmonized System code used for customs declaration.',
    supplierCertsAggregateLabel: 'This supplier offers products with these certifications:',
    supplierCertifiedPill: 'Certified',
    // Phase 6A — buyer-facing supplier profile additions
    spFactoryPhotosLabel: 'Factory Photos',
    spProfileBeingSetup: 'This supplier is still setting up their profile. Check back soon for products and certifications.',
    // Phase 6B — AI translation pill + toggle on supplier profile free-text fields
    spAiTranslated: 'AI translated',
    spShowOriginal: 'Show original',
    spShowTranslation: 'Show translation',
    spTranslationUnavailable: 'Translation unavailable',
    // Phase 6D — quality certifications multi-entry UI + buyer-facing cert links
    certAddBtn: '+ Add certification',
    certUploadBtn: 'Upload file',
    certUploadingLabel: 'Uploading...',
    certReplaceBtn: 'Replace',
    certUploadedLabel: 'Uploaded',
    certUploadFailed: 'Upload failed',
    certFileTypesHint: 'PDF, JPG, PNG · 10 MB max per file',
    certNamePlaceholder: 'e.g. ISO 9001',
    spViewCertificate: 'View Certificate →',
    buyerOrderTermsTitle: 'Trade Terms',
    buyerOrderProductLabel: 'Product',
    buyerOrderEmpty: '—',
    // Phase 5D — ProductDetail buyer-visible strings (i18n cleanup)
    pdBackBtn: 'Back',
    pdProductNotFound: 'Product not found',
    pdVerifiedSupplierPill: 'Verified supplier',
    pdSampleAvailablePill: 'Sample available',
    pdAlternateNameFn: (name) => `Factory / alternate name: ${name}`,
    pdOriginalPriceFn: (formatted) => `Original price: ${formatted}`,
    pdPerUnit: 'unit',
    pdMinOrderLabel: 'Min. Order',
    pdSupplierLabel: 'Supplier',
    pdOriginLabel: 'Origin',
    pdSampleLabel: 'Sample',
    pdSourcingSnapshotTitle: 'Sourcing snapshot',
    pdSourcingSnapshotBody: 'This page surfaces the details buyers usually expect in a China sourcing flow: MOQ, lead time, samples, customization, and supplier trust before you order or chat.',
    pdSourcingMoqLabel: 'MOQ',
    pdSourcingLeadTimeLabel: 'Lead time',
    pdSourcingCustomizationLabel: 'Customization',
    pdSourcingSamplesLabel: 'Samples',
    pdSourcingPackagingLabel: 'Packaging',
    pdLeadTimeDaysFn: (n) => `${n} days`,
    pdCustomizationNotSpecified: 'Not specified',
    pdSamplesAvailableValue: 'Available',
    pdSamplesNotAvailableValue: 'Not available',
    pdAttributesTitle: 'Attributes',
    pdLoadingOptions: 'Loading options…',
    pdSelectOptions: 'Select Options',
    pdPriceLabel: 'Price',
    pdStockLabel: 'Stock',
    pdOutOfStock: 'Out of stock',
    pdSelectAllToSeePrice: 'Select all options to see pricing',
    pdQuantity: 'Quantity',
    pdQuantityPlaceholder: 'e.g. 200',
    pdAddToOrder: '+ Add to Order',
    pdOrderSummary: 'Order Summary',
    pdNoVariantsAdded: 'No variants added yet. Select options and add a quantity.',
    pdQty: 'Qty',
    pdUnit: 'Unit',
    pdTotal: 'Total',
    pdRemove: 'Remove',
    pdGrandTotalFn: (n) => `Grand Total (${n} units)`,
    pdRequestQuote: 'Request Quote →',
    pdMaabarReviewLabel: 'Maabar review',
    pdMaabarReviewYes: 'This supplier is visible to buyers after Maabar review.',
    pdMaabarReviewNo: 'Approved supplier',
    pdTrustSignalsLabel: 'Trust signals',
    pdTrustTradeProfile: 'trade profile available',
    pdTrustNoTradeProfile: 'no public trade profile shown',
    pdTrustWeChat: 'WeChat available',
    pdTrustFactoryMedia: 'factory photos available',
    pdCommercialIdentityLabel: 'Commercial identity',
    pdSupplierIdFn: (id) => `Supplier ID: ${id}`,
    pdSupplierIdMissing: 'Supplier ID not shown yet',
    pdYearsExperienceFn: (n) => `${n} years experience`,
    pdVerifiedShort: 'Verified',
    pdReviewsCountFn: (n) => `${n} reviews`,
    pdSupplierIdLabel: 'Supplier ID',
    pdCompanyStoreLink: 'Company / store link',
    pdCtaHelper: 'You can order directly from this page, or message the supplier first to confirm packaging, customization, lead time, or shipping terms.',
    pdBuyNowBtn: 'Buy Now',
    pdQuoteCta: 'Request a quote',
    pdMessageSupplierCta: 'Message the supplier',
    pdMsgStarting: 'Opening…',
    pdQuoteNote: 'The supplier responds with pricing — no budget needed.',
    pdZoomHint: 'Click to zoom',
    pdDescLabel: 'Description',
    pdCustomizationLabel: 'Customization options',
    pdOnRequest: 'On request',
    pdRequestSampleFn: (price) => `Request Sample — ${price} SAR`,
    pdContactSupplierBtn: 'Contact Supplier',
    pdBuyModalTitle: 'Enter Quantity',
    pdBuyModalQtyLabel: 'Quantity *',
    pdBuyModalNoteLabel: 'Note (optional)',
    pdBuyModalNotePlaceholder: 'e.g. packaging, final specs, private label...',
    pdBuyModalSigninWarning: "* You'll be asked to sign in",
    pdBuyModalSubmit: 'Send Order →',
    pdCancelBtn: 'Cancel',
    pdOrderSentTitle: 'Your order has been sent — awaiting supplier confirmation',
    pdOrderSentBody: "The supplier has 24 hours to confirm. Once confirmed, you'll get a notification and can pay to start production.",
    pdBackToProducts: 'Back to Products',
    pdViewMyOrders: 'View My Orders',
    pdSampleModalTitle: 'Request Sample',
    pdSampleModalSubtitleFn: (price, shipping) => `Unit: ${price} SAR + Shipping: ${shipping} SAR`,
    pdSampleBadge: 'SAMPLE',
    pdSampleQtyLabelFn: (max) => `Quantity (max ${max})`,
    pdSampleTotalLabel: 'TOTAL',
    pdSampleNoteLabel: 'Note',
    pdSampleNotePlaceholder: 'Color, specs...',
    pdSampleModalSigninWarning: "* You'll be asked to sign in when submitting",
    pdSampleSubmit: 'Send Sample Request →',
    // Buyer-visible alert messages (kept in T-table per Phase 5D i18n rule)
    pdAlertSupplierNotFound: 'Supplier not found, try again',
    pdAlertValidQuantity: 'Please enter a valid quantity',
    pdAlertSelectAllOptions: 'Please select all options first',
    pdAlertMinQtyFn: (qty) => `Minimum order quantity is ${qty} units`,
    pdAlertAddVariant: 'Add at least one variant to your order',
    pdAlertQuoteSent: '✅ Quote request sent! The supplier will contact you soon.',
    pdAlertMaxSampleQtyFn: (max) => `Max sample quantity is ${max}`,
    pdAlertSampleSent: '✅ Sample request sent! The supplier will contact you soon',
    pdShippingOptionsTitle: 'Shipping Options',
    pdShipMethodSea: 'Sea',
    pdShipMethodAir: 'Air',
    pdShipMethodExpress: 'Express',
    pdShipMethodLand: 'Land',
  },
  zh: {
    tag: 'Maabar · 供应商控制台', welcome: '欢迎，', desc: '在一个地方管理您的报价、产品和消息', supplierStageLabel: '账户状态', supplierIdLabel: 'Maabar 供应商编号',
    overview: '概览', myProducts: '我的产品', offers: '我的报价', addProduct: '添加产品',
    messages: '消息', settings: '账户设置', offersCount: '已提交报价',
    productsCount: '活跃产品', messagesCount: '新消息',
    browseRequests: '浏览采购商需求', addNewProduct: '添加新产品',
    quickActions: '快速操作', stats: '数据概览', backHome: '← 返回首页', back: '← 返回',
    myOffers: '我的报价', noOffers: '暂无报价', browseReqs: '浏览需求',
    trackingPrompt: '输入物流单号以通知采购商', trackingNum: '物流单号', send: '发送',
    contactTrader: '联系采购商', tracking: '物流单号：',
    messagesTitle: '消息', noMessages: '暂无消息',
    addProductTitle: '添加新产品', myProductsTitle: '我的产品', noProducts: '暂无产品',
    nameAr: '阿拉伯语名称', nameEn: '英文名称 *', nameZh: '中文名称 *',
    category: '产品分类', currency: '货币', price: '起始价格 *', moq: '最小起订量 *', descLabel: '阿拉伯语描述', descEnLabel: '英文描述 *', descHint: '阿拉伯语可选，英文作为主描述，后续更方便做展示与翻译。',
    save: '保存', cancel: '取消', saving: '...',
    edit: '编辑', delete: '删除', confirmDelete: '确认删除此产品？',
    active: '上架', inactive: '下架', toggleActive: '切换状态',
    needsAttention: '需要处理', acceptedOffer: '报价已接受 — 联系采购商',
    offerRejected: '您的报价被拒绝',
    uploadImage: '上传图片', uploadVideo: '上传视频',
    uploadingImage: '上传中...', uploadingVideo: '上传中...',
    imageUploaded: '图片已上传', videoUploaded: '视频已上传', maxVideo: '最大 200MB',
    galleryImages: '产品图片', addMoreImages: '继续添加图片', galleryHint: '最多 8 张图片 — 第一张将作为主图', maxImagesReached: '已达到上限（8 张）', maxImagesError: '最多可上传 8 张图片', removeMedia: '删除', previewStep: '发布前预览', continueToPreview: '继续预览', backToEdit: '返回编辑', publishNow: '发布产品', previewNote: '发布前请先确认媒体、规格和价格。这里的显示货币不会替代产品原始货币。', previewBadge: '预览', previewEmptyMedia: '暂未添加产品图片', primaryImage: '主图', videoLimitHint: '每个产品仅支持 1 个视频',
    specsTitle: '产品规格', specMaterial: '材质', specDimensions: '尺寸 / 规格', specWeight: '单件重量', specColors: '颜色 / 款式', specPackaging: '包装信息', specCustomization: '定制 / OEM', specLeadTime: '交期（天）', productSavedWithFallback: '产品已保存，但部分新字段仍需要先执行数据库迁移后才能完整持久化。',
    sampleSettings: '样品设置', sampleAvailable: '可提供样品',
    samplePrice: '样品价格 (USD)', sampleShipping: '运费 (USD)',
    sampleMaxQty: '最大样品数量', sampleNote: '样品备注',
    settingsTitle: '账户设置', companyName: '公司名称',
    bioAr: '公司介绍（阿拉伯语）', bioEn: '公司介绍（英语）', bioZh: '公司介绍（中文）',
    whatsapp: 'WhatsApp', wechat: 'WeChat', city: '城市', country: '国家',
    tradeLink: '贸易主页 / 店铺链接', speciality: '专业领域', minOrder: '最低订单金额 (USD)',
    logo: '公司Logo', factoryImages: '工厂图片（最多3张）',
    uploadLogo: '上传Logo', uploadFactory: '添加图片', uploadingLogo: '上传中...',
    saveSettings: '保存设置', settingsSaved: '保存成功', saveAndContinue: '保存并进入第 2 步', verificationReviewRequired: '提交认证前，请先打开最终确认步骤。', days: '天',
    verificationTab: '收款资料', verificationTitle: '完成企业认证', verificationIntro: '注册后在这里补充完整认证资料和文件，初始注册不再要求一次填完。',
    verificationStatusIncomplete: '认证未完成', verificationStatusComplete: '认证资料已提交审核', verificationStatusLocked: '账户正在审核中',
    verificationCtaTitle: '请完成企业认证', verificationCtaBody: '请提交注册资料、工厂证明和经验信息，审核流程才会开始。', verificationCtaAction: '去完成认证 →',
    uploadProductsBannerTitle: '账户审核中 — 现在开始上传您的产品', uploadProductsBannerBody: '审核通过后，您的产品将立即对沙特买家可见。提前上传，从第一天起就做好准备。', uploadProductsBannerAction: '立即上传产品 →',
    legalRepIdLabel: '法定代表人身份证', addressProofLabel: '工厂/办公室地址证明', verificationPrivacyNote: '您的文件存储在私有空间，不会通过公开链接暴露。银行信息将在审核通过后单独收集。',
    onbWelcomeTitle: '恭喜您通过审核！', onbWelcomeIntro: '您的账户已在 Maabar 完成认证。让我们完成最后的设置步骤，迎接买家询单。', onbWelcomeBtn: '开始设置 →',
    onbProfileTitle: '完善公司资料', onbProfileFieldDescription: '公司简介', onbProfileFieldBusinessType: '经营类型', onbProfileFieldYearEstablished: '成立年份', onbProfileFieldNumEmployees: '员工数量', onbProfileFieldExportMarkets: '出口市场', onbProfileFieldExportMarketsHint: '请用逗号分隔不同市场（例如：沙特、阿联酋、约旦）。', onbProfileFieldCertifications: '质量认证', onbProfileFieldCertificationsHint: '每行填写一项认证（例如：ISO 9001）。', onbProfileFieldWebsite: '公司官网', onbSaveContinueBtn: '保存并继续', onbSavingError: '保存失败，请重试。',
    onbBankTitle: '添加收款信息', onbBankNote: '您的银行信息经过加密保护，仅用于向您转账。', onbBankFieldBeneficiary: '收款人姓名', onbBankFieldBankName: '银行名称', onbBankFieldAccountNumber: '账户号码', onbBankFieldSwift: 'SWIFT代码', onbBankFieldIban: 'IBAN（可选）', onbBankFieldCurrency: '首选显示货币', onbBankSkipLink: '稍后完成', onbBankRequiredError: '请填写收款人姓名、银行名称、账户号码和 SWIFT 代码，或点击"稍后完成"。',
    onbReadyTitle: '您已准备好！开始上传产品', onbReadyBody: '平台正式上线后，您的产品将展示给沙特买家。', onbReadyPrimaryBtn: '上传第一个产品', onbReadySecondaryBtn: '浏览采购需求',
    regNumber: '公司注册号 *', yearsExp: '从业年限 *', employees: '员工人数（可选）', businessLicense: '营业执照或企业身份证明 *', factoryPhoto: '工厂或仓库照片 *', replaceFile: '更换文件', viewCurrentFile: '查看当前文件', secureStorageNote: '这些文件保存在私有存储中，不会通过公开链接暴露。', verificationSubmitted: '认证资料已提交，账户当前处于审核中。', verificationMissing: '请填写所有必填认证信息并上传所需文件。', verificationVideoRequired: '请在提交认证前至少上传一个工厂视频。', verificationProfileRequired: '请先完成并保存基础公司资料，再提交认证。',
    payoutTab: '收款', payoutTitle: '收款设置', payoutIntro: '请补充您的银行信息，以便未来通过 Maabar 接收款项。', payoutNote: '这些信息会被安全保存。', payoutLocked: '账户审核通过后才可填写收款资料。', payoutCtaTitle: '请完成收款资料', payoutCtaBody: '您的账户已通过审核，但银行收款资料仍未填写完整。', payoutCtaAction: '去填写收款资料 →', payoutSaved: '收款信息已保存', payoutReassurance: '您的银行信息仅用于收款，Maabar 不会向您收取任何费用。', beneficiaryName: '收款人姓名', bankName: '银行名称', bankAccountNumber: '银行账号', swiftCode: 'SWIFT / BIC', bankAddress: '银行地址', preferredCurrency: '首选货币', branchNameOptional: '分行名称（可选）', ibanOptional: 'IBAN（可选）', savePayout: '保存收款信息', onboardingTitle: '您的账户已启用 — 认证仍在进行中', onboardingBody: '您现在就可以上架产品、接收采购需求、发送报价并与买家沟通。认证用于解锁收款，并为您的主页添加认证标识。', onboardingProgress: '申请进度', onboardingLockedTitle: '认证解锁的内容', onboardingLockedBody: '仅收款被锁定：认证通过前无法收到款项。产品、报价、消息和采购需求现在都已开放。', onboardingStepApply: '1) 完成基础资料', onboardingStepReview: '2) 提交认证进入审核', onboardingStepVisibility: '3) 通过认证以接收款项', onboardingGoSettings: '资料设置', onboardingVerificationReady: '提交认证后，账户会直接进入审核阶段。', verificationSubmitAction: '提交认证',
    tieredPricingTitle: '阶梯定价 *',
    tieredPricingHint: '第 1 档为必填。第 2、3 档可选：如数量越大价格越低，可补充填写。',
    tierColTier: '档位', tierColMinQty: '起始数量', tierColMaxQty: '截止数量', tierColUnitPrice: '单价',
    tierLabel: (n) => `档位 ${n}`,
    tierAndAbove: '及以上',
    tierAutoFromMoq: '默认等于 MOQ（可修改）',
    tierPriceRange: (lo, hi, currency) => `${lo}–${hi} ${currency} / 件`,
    moqValidationMin: 'MOQ 必须是 ≥ 1 的整数。',
    composerRequiredFields: '请先填写：中文名、英文名、英文描述、MOQ，以及 3 档阶梯定价。',
    tierValidationCount: '请至少填写第 1 档的单价。',
    tierValidationGap: (n) => `档位 ${n}：请先填写档位 ${n - 1}。`,
    tierValidationNumeric: (n) => `档位 ${n}：请输入有效的数值。`,
    tierValidationQtyFromMissing: (n) => `档位 ${n}：请输入起始数量。`,
    tierValidationQtyToMissing: (n) => `档位 ${n}：请输入截止数量。`,
    tierValidationPriceMissing: (n) => `档位 ${n}：请输入单价。`,
    tierValidationQtyFromMin: (n) => `档位 ${n}：起始数量需 ≥ 1。`,
    tierValidationPricePositive: (n) => `档位 ${n}：单价必须大于 0。`,
    tierValidationQtyOrder: (n) => `档位 ${n}：截止数量需大于起始数量。`,
    tierValidationOverlap: (n) => `档位 ${n}：数量区间与上一档位重叠。`,
    tierValidationDescending: (n) => `档位 ${n}：单价必须低于上一档位。`,
    tiersStillLoading: '正在加载当前价格……请稍候再保存。',
    tierSaveFailed: '产品已保存，但价格未能保存。请打开产品，重新填写价格并保存。',
    noPriceBadge: '未定价',
    addYourPrice: '填写价格',
    noPriceHint: '未定价的产品在目录和首页中排在已定价产品之后。',
    secMedia: '媒体',
    secBasicInfo: '基本信息',
    secPricing: '定价与运输',
    secSpecs: '规格与包装',
    secCertifications: '认证与合规',
    secSamples: '样品与定制',
    sectionBadgeAllDone: '已完成',
    sectionBadgeOptional: '可选',
    sectionBadgeProgress: (done, total) => `${done}/${total} 必填项`,
    hsCodeLabel: '海关编码 (HS Code)',
    hsCodeHint: 'AI 智能建议即将上线',
    hsCodePlaceholder: '例：8517.62.00',
    countryOfOriginLabel: '原产国',
    countryChina: '中国',
    countryVietnam: '越南',
    countryTurkey: '土耳其',
    countryIndia: '印度',
    countryPakistan: '巴基斯坦',
    countryBangladesh: '孟加拉国',
    countryIndonesia: '印度尼西亚',
    countryOther: '其他',
    countryOtherPlaceholder: '请填写国家',
    incotermsLabel: '贸易术语 (Incoterms) *',
    incotermsHint: '可多选',
    incotermFob: 'FOB',
    incotermCif: 'CIF',
    incotermExw: 'EXW',
    incotermDdp: 'DDP',
    ddpTooltip: '需要在沙特阿拉伯有报关代理。',
    incotermsValidation: '请至少选择一个贸易术语。',
    portOfLoadingLabel: '装运港 *',
    portShanghai: '上海',
    portShenzhen: '深圳',
    portNingbo: '宁波',
    portGuangzhou: '广州',
    portQingdao: '青岛',
    portTianjin: '天津',
    portOther: '其他',
    portOtherPlaceholder: '请填写港口',
    portValidation: '请选择装运港。',
    priceValidityLabel: '价格有效期',
    priceValidity30: '30 天',
    priceValidity60: '60 天',
    priceValidity90: '90 天',
    leadTimeSection: '生产交期',
    leadTimeMin: '最短（天）',
    leadTimeMax: '最长（天）',
    leadTimeNegotiable: '大订单可议',
    leadTimeOrderError: '最长交期需 ≥ 最短交期。',
    unitsPerCartonLabel: '每箱数量',
    cbmLabel: 'CBM（每箱立方米）',
    cbmCalcBtn: '根据外箱尺寸计算',
    cbmCalcMissingDims: '请先填写外箱尺寸（例：60×40×30 cm）。',
    cbmCalcParseFail: '尺寸无法解析。请使用 60×40×30 cm 这样的格式。',
    grossWeightLabel: '毛重（kg）',
    netWeightLabel: '净重（kg）',
    certificationsTitle: '认证与合规',
    certificationsHint: '添加 SASO、CE、FCC、ISO 等（实际上传将于下一阶段开放）。',
    certComingSoon: '证书上传功能即将开放',
    oemAvailableLabel: '支持 OEM（贴牌）',
    odmAvailableLabel: '支持 ODM（定制设计）',
    oemHint: 'OEM = 在现有产品上贴你的品牌。ODM = 我们为你做定制设计与工程。',
    oemLeadTimeSection: 'OEM/ODM 交期',
    oemLeadTimeMin: '最短（天）',
    oemLeadTimeMax: '最长（天）',
    completenessRequired: '必填字段',
    completenessRecommended: '建议字段',
    completenessMedia: '媒体（≥3 张图片 + 1 个视频）',
    completenessCerts: '至少 1 项认证',
    // Phase 4 — certifications uploader
    certAddBtn: '+ 添加认证',
    certTypeLabel: '认证类型',
    certNameLabel: '认证名称',
    certNameHint: '选择"其他"时必填',
    certIssuedDateLabel: '颁发日期',
    certExpiryDateLabel: '到期日期',
    certUploadFile: '上传 PDF',
    certReplaceFile: '更换',
    certUploaded: '已上传',
    certViewFile: '查看文件',
    certRemoveBtn: '删除',
    certNoneYet: '尚未添加任何认证。',
    certPdfOnly: '仅接受 PDF 文件。',
    certTooLarge: 'PDF 文件需 ≤ 10MB。',
    certPickTypeFirst: '请先选择认证类型。',
    certMaxReachedFn: (n) => `最多 ${n} 项认证。`,
    // Phase 4 — HS code AI suggester
    hsCodeSuggestBtn: 'AI 建议 HS 编码',
    hsCodeSuggesting: '生成中…',
    hsCodeSuggestNoName: '请先填写英文产品名。',
    hsCodeSuggestEmpty: '未返回建议。',
    hsCodeSuggestFailed: '获取建议失败，请稍后再试。',
    hsCodeSuggestionsTitle: 'AI 建议',
    // Phase 4 — i18n cleanup (was inline ternary)
    attrNamePlaceholder: '属性名（如：颜色）',
    attrValuePlaceholder: '输入值后按 Enter',
    attrAddBtn: '添加',
    attributesTitle: '自定义属性',
    attributesAddBtn: '+ 添加属性',
    attributesEmptyHint: '添加自定义属性，如颜色、尺寸、功率等。',
    specUnitWeightKg: '单件重量（kg）',
    specCartonDimensions: '外箱尺寸',
    sampleFreeFromQtyLabel: '免费样品起订量门槛（件）',
    variantToggleTitle: '该产品有多个规格/变体（颜色、尺寸等）',
    variantToggleHint: '开启后可设置颜色、尺寸等选项，并为每个组合单独定价',
    readinessTitle: '发布完整度',
    previewListingReadiness: '发布摘要',
    previewReadinessSummaryFn: (pct, done, total) => `发布完整度 ${pct}%（${done}/${total}）`,
    previewImageCountFn: (n) => `${n} 张图片`,
    previewSpecsCountFn: (n) => `${n} 项规格`,
    previewSamplesEnabled: '样品已开启',
    previewDisplayedNames: '展示名称',
    previewNameZhLabel: '中文名',
    previewNameEnLabel: '英文名',
    previewNameArLabel: '阿拉伯语名',
    previewCustomAttributes: '自定义属性',
    // Phase 4 — validation polish
    cbmPositiveError: 'CBM 必须大于 0。',
    weightPositiveError: '重量必须大于 0。',
    // Phase 5B — buyer-facing block titles & helpers
    buyerBlockPricingTitle: '定价与贸易条款',
    buyerBlockComplianceTitle: '合规与认证',
    buyerBlockCustomizationTitle: '定制',
    buyerCurrencyLabel: '货币',
    buyerPriceValidityLabel: '价格有效期',
    priceValidDaysFn: (days) => `有效期 ${days} 天`,
    buyerIncotermsLabel: '贸易术语 (Incoterms)',
    buyerPortOfLoadingLabel: '装运港',
    buyerLeadTimeLabel: '生产交期',
    leadTimeBuyerFn: (min, max, negotiable) => {
      const core = min !== null && max !== null
        ? (min === max ? `${min}` : `${min}–${max}`)
        : `${min ?? max}`;
      return `${core} 天${negotiable ? ' · 可议' : ''}`;
    },
    certSaudiReadyBadge: '符合沙特要求',
    certIssuedShort: '颁发',
    certExpiresShort: '到期',
    certDownloadPdf: '下载 PDF',
    customizationContactHelper: '请联系供应商讨论定制选项。',
    buyerOemLeadTimeFn: (min, max) => {
      const core = min !== null && max !== null
        ? (min === max ? `${min}` : `${min}–${max}`)
        : `${min ?? max}`;
      return `${core} 天`;
    },
    // Phase 5C — listing card chips
    cardMoqFn: (qty) => `起订量 ${qty}`,
    cardLeadTimeFn: (min, max) => {
      const core = min !== null && max !== null
        ? (min === max ? `${min}` : `${min}–${max}`)
        : `${min ?? max}`;
      return `${core} 天`;
    },
    // Phase 5D — buyer-facing logistics + HS code + supplier cert aggregate + order terms
    buyerBlockLogisticsTitle: '物流与运输',
    buyerLogisticsHelper: '将这些数据交给货运代理，可用于估算到岸成本。',
    buyerHsCodeTooltip: 'HS 海关编码，用于报关。',
    supplierCertsAggregateLabel: '此供应商的产品具备以下认证：',
    supplierCertifiedPill: '已认证',
    // Phase 6A — buyer-facing supplier profile additions
    spFactoryPhotosLabel: '工厂照片',
    spProfileBeingSetup: '该供应商正在完善资料。请稍后再访问以查看产品与认证。',
    // Phase 6B — AI translation pill + toggle on supplier profile free-text fields
    spAiTranslated: 'AI 翻译',
    spShowOriginal: '显示原文',
    spShowTranslation: '显示翻译',
    spTranslationUnavailable: '翻译不可用',
    // Phase 6D — quality certifications multi-entry UI + buyer-facing cert links
    certAddBtn: '+ 添加认证',
    certUploadBtn: '上传文件',
    certUploadingLabel: '上传中...',
    certReplaceBtn: '替换',
    certUploadedLabel: '已上传',
    certUploadFailed: '上传失败',
    certFileTypesHint: 'PDF / JPG / PNG · 单个文件最大 10 MB',
    certNamePlaceholder: '例如：ISO 9001',
    spViewCertificate: '查看证书 →',
    buyerOrderTermsTitle: '贸易条款',
    buyerOrderProductLabel: '产品',
    buyerOrderEmpty: '—',
    // Phase 5D — ProductDetail buyer-visible strings (i18n cleanup)
    pdBackBtn: '返回',
    pdProductNotFound: '产品不存在',
    pdVerifiedSupplierPill: '认证供应商',
    pdSampleAvailablePill: '可提供样品',
    pdAlternateNameFn: (name) => `英文 / 其他名称：${name}`,
    pdOriginalPriceFn: (formatted) => `原始价格：${formatted}`,
    pdPerUnit: '件',
    pdMinOrderLabel: '起订量',
    pdSupplierLabel: '供应商',
    pdOriginLabel: '原产地',
    pdSampleLabel: '样品价',
    pdSourcingSnapshotTitle: '采购摘要',
    pdSourcingSnapshotBody: '此页面更贴近中国供应商常用展示方式：包含 MOQ、交期、样品、定制与供应商信任信息，便于先判断再沟通。',
    pdSourcingMoqLabel: '起订量',
    pdSourcingLeadTimeLabel: '备货周期',
    pdSourcingCustomizationLabel: '定制能力',
    pdSourcingSamplesLabel: '样品',
    pdSourcingPackagingLabel: '包装',
    pdLeadTimeDaysFn: (n) => `${n} 天`,
    pdCustomizationNotSpecified: '未说明',
    pdSamplesAvailableValue: '可提供',
    pdSamplesNotAvailableValue: '暂无',
    pdAttributesTitle: '产品属性',
    pdLoadingOptions: '正在加载选项…',
    pdSelectOptions: '选择规格',
    pdPriceLabel: '价格',
    pdStockLabel: '库存',
    pdOutOfStock: '缺货',
    pdSelectAllToSeePrice: '选择所有规格后显示价格',
    pdQuantity: '数量',
    pdQuantityPlaceholder: '例如：200',
    pdAddToOrder: '+ 加入订单',
    pdOrderSummary: '订单摘要',
    pdNoVariantsAdded: '尚未添加任何规格。请选择选项并填写数量。',
    pdQty: '数量',
    pdUnit: '单价',
    pdTotal: '总计',
    pdRemove: '移除',
    pdGrandTotalFn: (n) => `总计（${n} 件）`,
    pdRequestQuote: '发送报价请求 →',
    pdMaabarReviewLabel: 'Maabar 审核',
    pdMaabarReviewYes: '该供应商已通过 Maabar 审核并向买家展示。',
    pdMaabarReviewNo: '认证供应商',
    pdTrustSignalsLabel: '信任信号',
    pdTrustTradeProfile: '已提供店铺/官网链接',
    pdTrustNoTradeProfile: '暂无公开店铺链接',
    pdTrustWeChat: '支持 WeChat 沟通',
    pdTrustFactoryMedia: '提供工厂图片',
    pdCommercialIdentityLabel: '商业身份',
    pdSupplierIdFn: (id) => `供应商编号：${id}`,
    pdSupplierIdMissing: '暂无供应商编号',
    pdYearsExperienceFn: (n) => `${n} 年经验`,
    pdVerifiedShort: '已认证',
    pdReviewsCountFn: (n) => `${n} 条评价`,
    pdSupplierIdLabel: '供应商编号',
    pdCompanyStoreLink: '官网 / 店铺链接',
    pdCtaHelper: '您可以直接下单，也可以先联系供应商确认包装、定制、交期或运输方式。',
    pdBuyNowBtn: '立即下单',
    pdQuoteCta: '请求报价',
    pdMessageSupplierCta: '联系供应商',
    pdMsgStarting: '正在打开…',
    pdQuoteNote: '供应商会回复价格——无需填写预算。',
    pdZoomHint: '点击放大',
    pdDescLabel: '描述',
    pdCustomizationLabel: '定制选项',
    pdOnRequest: '面议',
    pdRequestSampleFn: (price) => `申请样品 — ${price} SAR`,
    pdContactSupplierBtn: '联系供应商',
    pdBuyModalTitle: '输入数量',
    pdBuyModalQtyLabel: '数量 *',
    pdBuyModalNoteLabel: '备注（选填）',
    pdBuyModalNotePlaceholder: '例如：包装、最终规格、定制标识…',
    pdBuyModalSigninWarning: '* 提交前需要先登录',
    pdBuyModalSubmit: '发送订单 →',
    pdCancelBtn: '取消',
    pdOrderSentTitle: '订单已发送，等待供应商确认',
    pdOrderSentBody: '供应商将在 24 小时内确认。确认后您会收到通知，可以付款开始备货。',
    pdBackToProducts: '返回产品',
    pdViewMyOrders: '查看我的订单',
    pdSampleModalTitle: '申请样品',
    pdSampleModalSubtitleFn: (price, shipping) => `样品单价：${price} SAR + 运费：${shipping} SAR`,
    pdSampleBadge: '样品',
    pdSampleQtyLabelFn: (max) => `数量（最多 ${max}）`,
    pdSampleTotalLabel: '总计',
    pdSampleNoteLabel: '备注',
    pdSampleNotePlaceholder: '颜色、规格…',
    pdSampleModalSigninWarning: '* 提交时需要先登录',
    pdSampleSubmit: '发送样品请求 →',
    // Buyer-visible alert messages (kept in T-table per Phase 5D i18n rule)
    pdAlertSupplierNotFound: '无法识别供应商，请稍后再试',
    pdAlertValidQuantity: '请输入有效数量',
    pdAlertSelectAllOptions: '请先选择所有选项',
    pdAlertMinQtyFn: (qty) => `最小起订量为 ${qty} 件`,
    pdAlertAddVariant: '请至少为订单添加一个规格',
    pdAlertQuoteSent: '✅ 已发送报价请求！供应商会尽快联系您。',
    pdAlertMaxSampleQtyFn: (max) => `样品最多 ${max} 件`,
    pdAlertSampleSent: '✅ 样品请求已发送，供应商会尽快联系您',
    pdShippingOptionsTitle: '运输选项',
    pdShipMethodSea: '海运',
    pdShipMethodAir: '空运',
    pdShipMethodExpress: '快递',
    pdShipMethodLand: '陆运',
  },
};
